import React, { KeyboardEventHandler, useRef } from 'react';
import { Controller, useForm } from 'react-hook-form';
import CustomButton from './CustomButton';
import { Box, Stack, Typography } from '@mui/material';
import TextInput from './TextInput';

export type ValidateCodeInputs = {
    code1: string;
    code2: string;
    code3: string;
    code4: string;
    code5: string;
    code6: string;
};

const VerifyPinComponent = ({ btnWidth, error, setError, validateCode, loading, handleResendCode, children }: any) => {
    const focus1 = useRef<HTMLInputElement>(null);
    const focus2 = useRef<HTMLInputElement>(null);
    const focus3 = useRef<HTMLInputElement>(null);
    const focus4 = useRef<HTMLInputElement>(null);
    const focus5 = useRef<HTMLInputElement>(null);
    const focus6 = useRef<HTMLInputElement>(null);

    const focusRefs = [focus1, focus2, focus3, focus4, focus5, focus6];
    // const [error, setError] = useState('');
    const { control, handleSubmit, getValues, setValue } = useForm<ValidateCodeInputs>({
        defaultValues: {
            code1: '',
            code2: '',
            code3: '',
            code4: '',
            code5: '',
            code6: '',
        },
    });

    // const validateCode = async (data: ValidateCodeInputs) => {
    //     const code = Object.values(data).join('');
    //     console.log('$$$$$ ~ validateCode ~ code:', code)
    //     if (code.length < 6) {
    //         setError('Please fill all the fields.');
    //     } else {
    //         setError('');
    //     }
    // };
    const handleBackspace: KeyboardEventHandler<HTMLDivElement> = (e) => {
        if (e.key === 'Backspace') {
            const currentRef = document.activeElement as HTMLInputElement;
            const currentIndex = focusRefs.findIndex((ref) => ref?.current === currentRef);
            if (currentIndex > 0 && currentRef.value === '') {
                const prevRef = focusRefs[currentIndex - 1]?.current;
                if (prevRef) {
                    prevRef.focus();
                    prevRef.value = '';
                }
            }
        }
    };

    const handleChange = (e: any, index: number) => {
        const text = e.target.value.replace(/[^0-9]/g, '').substring(0, 1);
        if (text && index < 5) {
            focusRefs[index + 1]?.current?.focus();
        }
        const values = getValues();
        const allFilled = Object.values(values).every((value) => value);
        if (allFilled) {
            setError('');
        }
    };
    const handlePaste = (e: React.ClipboardEvent) => {
        e.preventDefault();
        const pastedData = e.clipboardData
            .getData('Text')
            .replace(/[^0-9]/g, '')
            .substring(0, 6);
        pastedData.split('').forEach((char, i) => {
            setValue(`code${i + 1}` as keyof ValidateCodeInputs, char);
            const currentRef = focusRefs[i]?.current;
            if (currentRef) {
                currentRef.value = char;
                currentRef.dispatchEvent(new Event('input', { bubbles: true }));
                if (i < 5 && focusRefs[i + 1]?.current) {
                    focusRefs[i + 1].current?.focus();
                }
            }
        });
    };
    return (
        <Stack height={'100%'} direction="column" alignItems="center" justifyContent={'space-between'}>
            <Stack alignItems="center">
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        margin: '20px 0',
                    }}
                >
                    <Controller
                        name="code1"
                        control={control}
                        render={({ field: { onChange, value } }) => (
                            <TextInput
                                icon={null}
                                inputProps={{ maxLength: 1 }}
                                variant="standard"
                                placeholder=""
                                style={{
                                    width: '40px',
                                    fontSize: '24px',
                                    textAlign: 'center',
                                    margin: '0 5px',
                                    background: 'transparent',
                                }}
                                value={value}
                                inputRef={focus1}
                                onChange={(e) => {
                                    onChange(e.target.value);
                                    handleChange(e, 0);
                                }}
                                onPaste={handlePaste}
                                onKeyDown={handleBackspace}
                            />
                        )}
                    />
                    <Controller
                        name="code2"
                        control={control}
                        render={({ field: { onChange, value } }) => (
                            <TextInput
                                icon={null}
                                inputProps={{ maxLength: 1 }}
                                variant="standard"
                                placeholder=""
                                style={{
                                    width: '40px',
                                    fontSize: '24px',
                                    textAlign: 'center',
                                    margin: '0 5px',
                                    background: 'transparent',
                                }}
                                value={value}
                                inputRef={focus2}
                                onChange={(e) => {
                                    onChange(e.target.value);
                                    handleChange(e, 1);
                                }}
                                // onPaste={handlePaste}
                                onKeyDown={handleBackspace}
                            />
                        )}
                    />
                    <Controller
                        name="code3"
                        control={control}
                        render={({ field: { onChange, value } }) => (
                            <TextInput
                                icon={null}
                                inputProps={{ maxLength: 1 }}
                                variant="standard"
                                placeholder=""
                                style={{
                                    width: '40px',
                                    fontSize: '24px',
                                    textAlign: 'center',
                                    margin: '0 5px',
                                    background: 'transparent',
                                }}
                                value={value}
                                inputRef={focus3}
                                onChange={(e) => {
                                    onChange(e.target.value);
                                    handleChange(e, 2);
                                }}
                                // onPaste={handlePaste}
                                onKeyDown={handleBackspace}
                            />
                        )}
                    />
                    <Controller
                        name="code4"
                        control={control}
                        render={({ field: { onChange, value } }) => (
                            <TextInput
                                icon={null}
                                inputProps={{ maxLength: 1 }}
                                variant="standard"
                                placeholder=""
                                style={{
                                    width: '40px',
                                    fontSize: '24px',
                                    textAlign: 'center',
                                    margin: '0 5px',
                                    background: 'transparent',
                                }}
                                value={value}
                                inputRef={focus4}
                                onChange={(e) => {
                                    onChange(e.target.value);
                                    handleChange(e, 3);
                                }}
                                // onPaste={handlePaste}
                                onKeyDown={handleBackspace}
                            />
                        )}
                    />
                    <Controller
                        name="code5"
                        control={control}
                        render={({ field: { onChange, value } }) => (
                            <TextInput
                                icon={null}
                                inputProps={{ maxLength: 1 }}
                                variant="standard"
                                placeholder=""
                                style={{
                                    width: '40px',
                                    fontSize: '24px',
                                    textAlign: 'center',
                                    margin: '0 5px',
                                    background: 'transparent',
                                }}
                                value={value}
                                inputRef={focus5}
                                onChange={(e) => {
                                    onChange(e.target.value);
                                    handleChange(e, 4);
                                }}
                                // onPaste={handlePaste}
                                onKeyDown={handleBackspace}
                            />
                        )}
                    />
                    <Controller
                        name="code6"
                        control={control}
                        render={({ field: { onChange, value } }) => (
                            <TextInput
                                icon={null}
                                inputProps={{ maxLength: 1 }}
                                variant="standard"
                                placeholder=""
                                style={{
                                    width: '40px',
                                    fontSize: '24px',
                                    textAlign: 'center',
                                    margin: '0 5px',
                                    background: 'transparent',
                                }}
                                value={value}
                                inputRef={focus6}
                                onChange={(e) => {
                                    onChange(e.target.value);
                                    handleChange(e, 5);
                                }}
                                // onPaste={handlePaste}
                                onKeyDown={handleBackspace}
                            />
                        )}
                    />
                </div>
                {error && (
                    <Box>
                        <Typography variant="body1" sx={{ color: 'red' }}>
                            {error}
                        </Typography>
                    </Box>
                )}
            </Stack>
            <Stack width={'100%'} height="200px" justifyContent="space-between">
                {children}
                <Box sx={{ textAlign: 'center', width: '100%' }}>
                    <Stack justifyContent="center" alignItems="center" direction="row" mt={1} spacing={0.5}>
                        <Typography>Didn’t receive a code?</Typography>
                        <CustomButton
                            onClick={handleResendCode}
                            fontSize={14}
                            variant="text"
                            height="fit-content"
                            sx={{
                                p: 0,
                                textDecoration: 'underline',
                                '&:hover': {
                                    backgroundColor: 'transparent',
                                },
                            }}
                        >
                            Resend Code
                        </CustomButton>
                    </Stack>
                    <CustomButton
                        width={btnWidth || '100%'}
                        onClick={handleSubmit(validateCode)}
                        style={{ fontSize: '25px' }}
                        loading={loading}
                    >
                        Continue
                    </CustomButton>
                </Box>
            </Stack>
        </Stack>
    );
};

export default VerifyPinComponent;
